(function() {
    'use strict';

    var NotificheCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        notificheService,
        gestioneUtenteService
    ) {

        this.loading = 0;
        this.tipiNotifica = [];
        this.gestioneUtenteService = gestioneUtenteService;

        this.init = () => {
            this.tipiNotifica = [{
                    cod: CONSTANTS.DOMINI_NOTIFICHE.NESSUNO,
                    dsc: 'NESSUNO'
                },
                {
                    cod: CONSTANTS.DOMINI_NOTIFICHE.SMS,
                    dsc: 'SMS'
                },
                {
                    cod: CONSTANTS.DOMINI_NOTIFICHE.EMAIL,
                    dsc: 'EMAIL'
                }
            ];
        };

        this.init();
    };

    NotificheCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomNotificheService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-notifiche/notifiche.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var NotificheComponent = {
        controller: NotificheCtrl,
        controllerAs: 'notificheCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomnotifiche', NotificheComponent);
})();